import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { DatePipe } from "@angular/common";
import { BehaviorSubject } from "rxjs";

export interface BlogPayload {
  blog_id?: string | number;
  title: string;
  short_description: string;
  description: string;
  author: string;
  status: string;
  is_active: string;
  meta_title: string;
  meta_keywords: string;
  meta_description: string;
  h1_tag: string;
  blog_image: string | null;
  blog_image_existing: string;
  remove_existing_image: string;
}

@Injectable({
  providedIn: "root",
})
export class ServicesService {
  constructor(
    public https: HttpClient,
    private datePipe: DatePipe,
  ) { }

  // base_URL = `http://localhost/service_local/`;

  base_URL = `https://aieventzo.com/admin_services/`;
  app_URL = `https://aieventzo.com/app_services/`;

  event_id = sessionStorage.getItem("Event_ID");
  SO_Event_ID = sessionStorage.getItem("SO_Event_ID");
  updated_by = sessionStorage.getItem("User_ID");

  private imageSubject = new BehaviorSubject<string | ArrayBuffer | null>(null);
  image$ = this.imageSubject.asObservable();

  setImage(image: any) {
    console.log("SERVICE", image);

    this.imageSubject.next(image);
  }

  uploadimage(image: any, folder: string) {
    const url = this.base_URL + `uploadimage.php`;
    const data = {
      image: image,
      folder: folder,
    };
    return this.https.post(url, data);
  }

  login(user_name: any, user_pwd: any) {
    const url = this.base_URL + `login_admin.php`;
    const data = {
      username: user_name,
      password: user_pwd,
      platform: 'admin',
    };
    return this.https.post(url, data);
  }

  loginAuth(loginData: any) {
    const url = this.base_URL + `auth.php`;
    const data = {
      user_id: loginData.user_id,
      session_token: loginData.session_token,
      platform: 'admin',
    };
    return this.https.post(url, data);
  }

  login_otp(user_name: any) {
    const url = this.base_URL + `login_otp.php`;
    const data = {
      username: user_name,
      platform: 'admin',
    };
    return this.https.post(url, data);
  }

  login_catalogue(mobile: any, token: any) {
    const url = this.base_URL + `login_catalogue.php`;
    const data = {
      mobile: mobile,
      token: token,
      platform: 'admin',
    };
    return this.https.post(url, data);
  }

  verify_otp(user_name: any, otp: any) {
    const url = this.base_URL + `verify_otp.php`;
    const data = {
      mobile: user_name,
      otp: otp,
    };
    return this.https.post(url, data);
  }

  otp(mobile: any) {
    const url = this.base_URL + `otp.php`;
    const data = {
      mobile: mobile,
    };
    return this.https.post(url, data);
  }

  sendOtp(event_id: any, otpContact: any) {
    const url = this.base_URL + `reg_otp.php`;
    const data = {
      event_id: event_id,
      mobile: otpContact,
    };
    return this.https.post(url, data);
  }

  verifyOtp(otpContact: any, otpValue: any) {
    const url = this.base_URL + `verify_regotp.php`;
    const data = {
      mobile: otpContact,
      otp: otpValue,
    };
    return this.https.post(url, data);
  }

  get_event() {
    const url = this.base_URL + `get_events.php`;
    return this.https.get(url);
  }

  get_advertise() {
    const url = this.base_URL + `get_advertise.php`;
    return this.https.get(url);
  }

  get_advertise_by_id(ad_id: any) {
    const url = this.base_URL + `get_advertise_by_id.php`;
    const data = {
      ad_id: ad_id,
    };
    return this.https.post(url, data);
  }

  delete_advertise(ad_id: any) {
    const url = this.base_URL + `delete_advertise.php`;
    const data = {
      ad_id: ad_id,
    };
    return this.https.post(url, data);
  }

  get_eventtype() {
    const url = this.base_URL + `get_event_type.php`;
    return this.https.get(url);
  }
  get_stall_and_catalogues() {
    const url = this.base_URL + `get_stall_and_catalogues.php`;
    return this.https.get(url);
  }

  get_event_type_by_id(id: any) {
    const url = this.base_URL + `get_event_type_by_id.php`;
    const data = {
      id: id,
    };
    return this.https.post(url, data);
  }

  add_event_type(et: any) {
    const url = this.base_URL + `add_event_type.php`;
    const data = {
      event_type: et.event_type,
    };
    return this.https.post(url, data);
  }

  edit_event_type(et: any) {
    const url = this.base_URL + `edit_event_type.php`;
    const data = {
      id: et.id,
      event_type: et.event_type,
    };
    return this.https.post(url, data);
  }

  delete_event_type(id: any) {
    const url = this.base_URL + `delete_event_type.php`;
    const data = {
      id: id,
    };
    return this.https.post(url, data);
  }

  get_scanning_point_by_id(point_id: any) {
    const url = this.base_URL + `get_scanning_point_by_id.php`;
    const data = {
      point_id: point_id,
    };
    return this.https.post(url, data);
  }

  get_coupon_code_by_id(id: any) {
    const url = this.base_URL + `get_coupon_code_by_id.php`;
    const data = {
      id: id,
    };
    return this.https.post(url, data);
  }

  get_coupon_code_by_code(code: any, event_id: any) {
    const url = this.base_URL + `get_coupon_code_by_code.php`;
    const data = {
      code: code,
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  get_event_by_id(event_id: any) {
    const url = this.base_URL + `get_event_by_id.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  Log(file: any, ddata: any) {
    const url = this.base_URL + `log.php`;
    const data = {
      file: file,
      data: ddata,
    };
    return this.https.post(url, data);
  }

  edit_event_description(event_id: any, description: any) {
    const url = this.base_URL + `edit_event_description.php`;
    const data = {
      event_id: event_id,
      description: description
    };
    return this.https.post(url, data);
  }


  edit_update(Event_Data: any) {
    const url = this.base_URL + `edit_event.php`;
    const fromformattedDate = this.datePipe.transform(
      Event_Data.from_date,
      "yyyy-MM-dd",
    );
    const toformattedDate = this.datePipe.transform(
      Event_Data.to_date,
      "yyyy-MM-dd",
    );
    const userID = sessionStorage.getItem("User_ID");
    const data = {
      event_id: Event_Data.event_id,
      user_id: Event_Data.user_id ? Event_Data.user_id : userID,
      event_name: Event_Data.event_name,
      event_type: Event_Data.event_type ? Event_Data.event_type : "",
      description: Event_Data.description ? Event_Data.description : "",
      address: Event_Data.address ? Event_Data.address : "",
      company_pan: Event_Data.company_pan ? Event_Data.company_pan : "",
      organizer: Event_Data.organizer,
      reg_fee: Event_Data.reg_fee ? Event_Data.reg_fee : 0,
      from_date: fromformattedDate,
      to_date: toformattedDate,
      event_logo: Event_Data.event_logo,
      event_image: Event_Data.event_image,
      from_time: Event_Data.from_time,
      to_time: Event_Data.to_time,
      total_reg: Event_Data.total_reg,
      type: Event_Data.type,
      is_active: Event_Data.is_active,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  add_Event(Event_Data: any) {
    const url = this.base_URL + `add_event.php`;
    const fromformattedDate = this.datePipe.transform(
      Event_Data.from_date,
      "yyyy-MM-dd",
    );
    const toformattedDate = this.datePipe.transform(
      Event_Data.to_date,
      "yyyy-MM-dd",
    );
    const data = {
      event_id: Event_Data.event_id,
      user_id: Event_Data.user_id,
      event_name: Event_Data.event_name,
      event_type: Event_Data.event_type ? Event_Data.event_type : "",
      description: Event_Data.description ? Event_Data.description : "",
      address: Event_Data.address ? Event_Data.address : "",
      company_pan: Event_Data.company_pan ? Event_Data.company_pan : "",
      organizer: Event_Data.organizer,
      reg_fee: Event_Data.reg_fee ? Event_Data.reg_fee : 0,
      from_date: fromformattedDate,
      to_date: toformattedDate,
      event_logo: Event_Data.event_logo,
      event_image: Event_Data.event_image,
      from_time: Event_Data.from_time,
      to_time: Event_Data.to_time,
      total_reg: Event_Data.total_reg,
      type: Event_Data.type,
      is_active: Event_Data.is_active,
      created_by: Event_Data.user_id,
    };
    return this.https.post(url, data);
  }

  delete_event(event_id: any) {
    const url = this.base_URL + `delete_event.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  delete_all_pass(event_id: any) {
    const url = this.base_URL + `delete_all_pass.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  get_user(user_type: any) {
    const url = this.base_URL + `get_all_users.php`;
    const data = {
      type: user_type,
    };
    return this.https.post(url, data);
  }

  get_event_by_user(user_id: any) {
    const url = this.base_URL + `get_event_by_user.php`;
    const data = {
      user_id: user_id,
    };
    return this.https.post(url, data);
  }

  get_user_by_id(user_id: any) {
    const url = this.base_URL + `get_user_by_id.php`;
    const data = {
      user_id: user_id,
    };
    return this.https.post(url, data);
  }

  get_user_by_mobile(mobile: any) {
    const url = this.base_URL + `get_user_by_mobile.php`;
    const data = {
      user_mobile: mobile,
    };
    return this.https.post(url, data);
  }

  get_reg_by_id(reg_id: any) {
    const url = this.base_URL + `get_registration_by_id.php`;
    const data = {
      reg_id: reg_id,
    };
    return this.https.post(url, data);
  }

  get_reg_by_id_web(event_id: any, mem_id: any) {
    const url = this.base_URL + `get_registration_by_id_web.php`;
    const data = {
      event_id: event_id,
      mem_id: mem_id,
    };
    return this.https.post(url, data);
  }

  admin_add_registration(
    reg: any,
    logoPath: any,
    imagePath: any,
    paymentPath: any,
  ) {
    const url = this.base_URL + `add_registration.php`;
    const data = {
      event_id: this.event_id,
      image: imagePath,
      id_proof: logoPath,
      payment_ss: paymentPath,
      email: reg.email,
      name: reg.name,
      mobile: reg.mobile,
      city: reg.city,
      state: reg.state,
      address: reg.address,
      date: reg.date,
      allowed_person: reg.allowed_person ? reg.allowed_person : 1,
      whatsapp_status: reg.whatsapp_status,
      tic_category: reg.tic_category,
      field1: reg.field1,
      field2: reg.field2,
      field3: reg.field3,
      field4: reg.field4,
      field5: reg.field5,
      field6: reg.field6,
      field7: reg.field7,
      field8: reg.field8,
      field9: reg.field9,
      field10: reg.field10,
      field11: reg.field11,
      field12: reg.field12,
      field13: reg.field13,
      field14: reg.field14,
      field15: reg.field15,
      field16: reg.field16,
      field17: reg.field17,
      field18: reg.field18,
      field19: reg.field19,
      field20: reg.field20,
      field21: reg.field21,
      field22: reg.field22,
      field23: reg.field23,
      field24: reg.field24,
      field25: reg.field25,
      barcode: reg.barcode,
      created_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  admin_edit_registration(
    Reg_data: any,
    reg_id: any,
    logoPath: any,
    imagePath: any,
  ) {
    const url = this.base_URL + `edit_registration.php`;
    const data = {
      reg_id: reg_id,
      name: Reg_data.name,
      mobile: Reg_data.mobile,
      city: Reg_data.city,
      email: Reg_data.email,
      state: Reg_data.state,
      address: Reg_data.address,
      image: imagePath,
      id_proof: logoPath,
      whatsapp_status: Reg_data.whatsapp_status,
      // tic_category: Reg_data.tic_category,
      allowed_person: Reg_data.allowed_person ? Reg_data.allowed_person : 1,
      field1: Reg_data.field1,
      field2: Reg_data.field2,
      field3: Reg_data.field3,
      field4: Reg_data.field4,
      field5: Reg_data.field5,
      field6: Reg_data.field6,
      field7: Reg_data.field7,
      field8: Reg_data.field8,
      field9: Reg_data.field9,
      field10: Reg_data.field10,
      field11: Reg_data.field11,
      field12: Reg_data.field12,
      field13: Reg_data.field13,
      field14: Reg_data.field14,
      field15: Reg_data.field15,
      field16: Reg_data.field16,
      field17: Reg_data.field17,
      field18: Reg_data.field18,
      field19: Reg_data.field19,
      field20: Reg_data.field20,
      field21: Reg_data.field21,
      field22: Reg_data.field22,
      field23: Reg_data.field23,
      field24: Reg_data.field24,
      field25: Reg_data.field25,
      barcode: Reg_data.barcode,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  add_user(user: any) {
    const url = this.base_URL + `add_user.php`;
    const data = {
      user_name: user.user_name,
      user_mobile: user.user_mobile,
      user_pwd: user.user_pwd,
      is_active: user.is_active,
    };
    return this.https.post(url, data);
  }

  edit_user(user: any) {
    const url = this.base_URL + `edit_user.php`;
    const data = {
      user_id: user.user_id,
      user_name: user.user_name,
      user_mobile: user.user_mobile,
      user_pwd: user.user_pwd,
      reset_pwd: user.isResetMode,
      is_active: user.is_active,
    };
    return this.https.post(url, data);
  }

  delete_user(user_id: any) {
    const url = this.base_URL + `delete_user.php`;
    const data = {
      user_id: user_id,
    };
    return this.https.post(url, data);
  }

  getArtist(event_id: any) {
    const url = this.base_URL + `get_artists.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  getArtistByID(a_id: any) {
    const url = this.base_URL + `get_artist_by_id.php`;
    const data = {
      a_id: a_id,
    };
    return this.https.post(url, data);
  }

  add_artist(artist: any, updated_by: any) {
    const url = this.base_URL + `add_artist.php`;
    const data = {
      event_id: this.event_id,
      artist: artist.artist,
      role: artist.role,
      image_name: artist.image_name,
      description: artist.description,
      created_by: updated_by,
    };
    return this.https.post(url, data);
  }

  edit_artist(artist: any, updated_by: any) {
    const url = this.base_URL + `edit_artist.php`;
    const data = {
      event_id: this.event_id,
      a_id: artist.a_id,
      point: artist.point,
      artist: artist.artist,
      role: artist.role,
      image_name: artist.image_name,
      description: artist.description,
      updated_by: updated_by,
    };
    return this.https.post(url, data);
  }

  delete_artist(a_id: any) {
    const url = this.base_URL + `delete_artist.php`;
    const data = {
      a_id: a_id,
    };
    return this.https.post(url, data);
  }

  getSponsor(event_id: any) {
    const url = this.base_URL + `get_sponsor.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  getSponsorByID(s_id: any) {
    const url = this.base_URL + `get_sponsor_by_id.php`;
    const data = {
      s_id: s_id,
    };
    return this.https.post(url, data);
  }

  add_sponsor(sponsor: any, updated_by: any) {
    const url = this.base_URL + `add_sponsor.php`;
    const data = {
      event_id: this.event_id,
      sponsor_name: sponsor.sponsor_name,
      mobile: sponsor.mobile,
      amount: sponsor.amount,
      image_name: sponsor.image_name,
      category: sponsor.category,
      website: sponsor.website,
      created_by: updated_by,
    };
    return this.https.post(url, data);
  }

  edit_sponsor(sponsor: any, updated_by: any) {
    const url = this.base_URL + `edit_sponsor.php`;
    const data = {
      event_id: this.event_id,
      s_id: sponsor.s_id,
      sponsor_name: sponsor.sponsor_name,
      mobile: sponsor.mobile,
      amount: sponsor.amount,
      image_name: sponsor.image_name,
      category: sponsor.category,
      website: sponsor.website,
      updated_by: updated_by,
    };
    return this.https.post(url, data);
  }

  delete_sponsor(s_id: any) {
    const url = this.base_URL + `delete_sponsor.php`;
    const data = {
      s_id: s_id,
    };
    return this.https.post(url, data);
  }

  display(event_id: any) {
    const url = this.base_URL + `display.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  get_report(type: any, date: any, reg_date: any, point: any, tic_category: any) {
    const url = this.base_URL + `get_report.php`;
    const data = {
      event_id: this.event_id,
      type: type,
      date: date,
      reg_date: reg_date,
      point: point,
      tic_category: tic_category.category,
      category_id: tic_category.category_id,
    };
    return this.https.post(url, data);
  }

  get_offset_report(type: any, date: any, reg_date: any, point: any, tic_category: any, offset: any, limit: any) {
    const url = this.base_URL + `get_off_report.php`;
    const data = {
      event_id: this.event_id,
      type: type,
      date: date,
      reg_date: reg_date,
      point: point,
      tic_category: tic_category.category,
      category_id: tic_category.category_id,
      offset: offset,
      limit: limit,

    };
    return this.https.post(url, data);
  }

  gettransactions(event_id: any) {
    const url = this.base_URL + `get_transactions.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  getpoints() {
    const url = this.base_URL + `get_scanning_point.php`;
    const data = {
      event_id: this.event_id,
    };
    return this.https.post(url, data);
  }

  editAllowedPerson(reg_id: any, allowed_person: any) {
    const url = this.base_URL + `edit_allowed_person.php`;
    const data = {
      reg_id: reg_id,
      allowed_person: allowed_person,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  getsetting(event_id: any) {
    const url = this.base_URL + `get_setting.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  get_last_reports(event_id: any, last_reg_id: any) {
    const url = this.base_URL + `get_last_reports.php`;
    const data = {
      event_id: event_id,
      last_reg_id: last_reg_id,
    };
    return this.https.post(url, data);
  }

  edit_setting(setting: any) {
    const url = this.base_URL + `edit_setting.php`;
    const data = {
      event_id: this.event_id,
      registration: setting.registration,
      unique_mobile: setting.unique_mobile,
      contact_privacy: setting.contact_privacy,
      start_reg_from: setting.start_reg_from,
      reg_whatsapp_msg: setting.reg_whatsapp_msg,
      success_msg: setting.success_msg,
      display_msg: setting.display_msg,
      close_msg: setting.close_msg,
      send_email: setting.send_email,
      send_whatsapp_reg: setting.send_whatsapp_reg,
      send_whatsapp_msg: setting.send_whatsapp_msg,
      reg_url: setting.reg_url,
      ticket_print: setting.ticket_print,
      whatsapp_url: setting.whatsapp_url,
      url: setting.url,
      vendor_id: setting.vendor_id,
      method: setting.method,
      headers: setting.headers,
      body_template: setting.body_template,
      email_smtp: setting.email_smtp,
      email_subject: setting.email_subject,
      email_template: setting.email_template,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  get_reg_setting(event_id: any) {
    const url = this.base_URL + `get_regsetting.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  get_reg_setting_for_icard(event_id: any, mem_id: any) {
    const url = this.base_URL + `get_regsetting_for_icard.php`;
    const data = {
      event_id: event_id,
      mem_id: mem_id,
    };
    return this.https.post(url, data);
  }

  edit_reg_setting(setting: any, event_id: any) {
    const url = this.base_URL + `edit_regsetting.php`;
    const data = {
      event_id: event_id,
      reg_data: setting,
      created_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  app_edit_reg_setting(setting: any, event_id: any, user_id: any) {
    const url = this.base_URL + `edit_regsetting.php`;
    const data = {
      event_id: event_id,
      reg_data: setting,
      created_by: user_id,
    };
    return this.https.post(url, data);
  }

  get_scanning_point() {
    const url = this.base_URL + `get_scanning_point.php`;
    const data = {
      event_id: this.event_id,
    };
    return this.https.post(url, data);
  }

  get_category(so_id: any) {
    const url = this.base_URL + `get_category.php`;
    const data = {
      so_id: so_id,
    };
    return this.https.post(url, data);
  }

  get_catalogue_inquiry(so_id: any) {
    const url = this.base_URL + `get_catalogue_inquiry.php`;
    const data = {
      so_id: so_id,
    };
    return this.https.post(url, data);
  }

  get_category_by_id(category_id: any) {
    const url = this.base_URL + `get_category_by_id.php`;
    const data = {
      category_id: category_id,
    };
    return this.https.post(url, data);
  }

  add_category(category: any) {
    const url = this.base_URL + `add_category.php`;
    const data = {
      category: category.category,
      so_id: category.so_id,
    };
    return this.https.post(url, data);
  }
  edit_category(category: any) {
    const url = this.base_URL + `edit_category.php`;
    const data = {
      category_id: category.category_id,
      category: category.category,
    };
    return this.https.post(url, data);
  }
  delete_category(category_id: any) {
    const url = this.base_URL + `delete_category.php`;
    const data = {
      category_id: category_id,
    };
    return this.https.post(url, data);
  }

  get_products(so_id: any) {
    const url = this.base_URL + `get_products.php`;
    const data = {
      so_id: so_id,
    };
    return this.https.post(url, data);
  }

  get_product_by_id(id: any) {
    const url = this.base_URL + `get_product_by_id.php`;
    const data = {
      id: id,
    };
    return this.https.post(url, data);
  }

  add_product(product: any) {
    const url = this.base_URL + `add_product.php`;
    const data = {
      so_id: product.so_id,
      category_id: product.category_id,
      image_name: product.image_name,
      product_title: product.product_title,
      product_link: product.product_link,
      description: product.description,
      price: product.price,
      offer_price: product.offer_price,
    };
    return this.https.post(url, data);
  }

  edit_product(product: any) {
    const url = this.base_URL + `edit_product.php`;
    const data = {
      id: product.id,
      category_id: product.category_id,
      image_name: product.image_name,
      product_title: product.product_title,
      product_link: product.product_link,
      description: product.description,
      price: product.price,
      offer_price: product.offer_price,
    };
    return this.https.post(url, data);
  }

  delete_product(id: any) {
    const url = this.base_URL + `delete_product.php`;
    const data = {
      id: id,
    };
    return this.https.post(url, data);
  }

  add_product_qr_batch(batch: any) {
    const url = this.base_URL + `add_qr_batch.php`;
    const data = {
      event_id: batch.event_id,
      so_id: batch.so_id,
      product_id: batch.product_id,
      assigned_user_id: batch.assigned_user_id,
      batch_name: batch.batch_name,
      total_qr_count: batch.quantity,
      points_per_scan: batch.points_per_scan,
      expiry_date: batch.expiry_date,
      created_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  get_product_qr_batches(so_id: any) {
    const url = this.base_URL + `get_qr_batch.php`;
    const data = {
      so_id: so_id,
    };
    return this.https.post(url, data);
  }

  get_product_qr_codes(batch_id: any) {
    const url = this.base_URL + `get_qr_codes_by_batch.php`;
    const data = {
      batch_id: batch_id,
    };
    return this.https.post(url, data);
  }

  get_product_qr_hash_codes(batch_id: any) {
    const url = this.base_URL + `get_qr_hash_by_batch.php`;
    const data = {
      batch_id: batch_id,
    };
    return this.https.post(url, data);
  }

  update_product_qr_batch(batch_id: any, status: any) {
    const url = this.base_URL + `update_product_qr_batch.php`;
    const data = {
      batch_id: batch_id,
      status: status,
    };
    return this.https.post(url, data);
  }

  export_product_qr_codes(batch_id: any) {
    const url = this.base_URL + `export_product_qr_codes.php`;
    const data = {
      batch_id: batch_id,
    };
    return this.https.post(url, data, { responseType: "text" });
  }

  claim_product_qr(public_uid: any) {
    const url = this.app_URL + `claim_product_qr.php`;
    const data = {
      public_uid: public_uid,
      user_id: sessionStorage.getItem("User_ID") || sessionStorage.getItem("user_id"),
      session_token: sessionStorage.getItem("session_token") || sessionStorage.getItem("token"),
      platform: "admin",
    };
    return this.https.post(url, data);
  }

  get_product_qr_scan_analytics(batch_id: any) {
    const url = this.base_URL + `get_product_qr_scan_analytics.php`;
    const data = {
      batch_id: batch_id,
    };
    return this.https.post(url, data);
  }

  check_coupon(event_id: any) {
    const url = this.base_URL + `check_coupon.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  get_coupon_code(event_id: any) {
    const url = this.base_URL + `get_coupon_code.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  get_admin_users() {
    const url = this.base_URL + `get_admin_user.php`;
    const data = {
      event_id: this.event_id,
    };
    return this.https.post(url, data);
  }

  get_stall() {
    const url = this.base_URL + `get_stall.php`;
    const data = {
      event_id: this.event_id,
    };
    return this.https.post(url, data);
  }

  get_my_stall(user_id: any) {
    const url = this.base_URL + `get_my_stall.php`;
    const data = {
      user_id: user_id,
      event_id: this.event_id,
      so_event_id: this.SO_Event_ID,
    };
    return this.https.post(url, data);
  }
  get_stall_scan(so_id: any) {
    const url = this.base_URL + `get_stall_scan.php`;
    const data = {
      so_id: so_id,
    };
    return this.https.post(url, data);
  }

  get_available_stall() {
    const url = this.base_URL + `get_available_stall.php`;
    const data = {
      event_id: this.event_id,
    };
    return this.https.post(url, data);
  }

  get_stall_by_id(id: any) {
    const url = this.base_URL + `get_stall_by_id.php`;
    const data = {
      id: id,
    };
    return this.https.post(url, data);
  }

  get_stall_owner_by_id(so_id: any) {
    const url = this.base_URL + `get_stall_owner_by_id.php`;
    const data = {
      so_id: so_id,
    };
    return this.https.post(url, data);
  }

  add_stall(stall: any) {
    const url = this.base_URL + `add_stall.php`;
    const data = {
      event_id: this.event_id,
      stall_num: stall.stall_num,
      price: stall.price,
      size: stall.size,
      description: stall.description,
      created_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  add_stall_scan(stall: any) {
    const url = this.base_URL + `add_stall_scan.php`;
    const data = {
      event_id: 7,
      so_id: stall.so_id,
      mem_id: stall.mem_id,
      name: stall.name,
      mobile: stall.mobile,
      interests: stall.interests.toString(),
      other: stall.other,
      created_by: stall.created_by,
    };
    return this.https.post(url, data);
  }

  add_stall_owner(owner: any) {
    const url = this.base_URL + `add_stall_owner.php`;
    const data = {
      event_id: this.event_id,
      stall_id: owner.stall_id,
      image_name: owner.image_name,
      owner_name: owner.owner_name,
      owner_number: owner.owner_number,
      email: owner.email,
      company_name: owner.company_name,
      address: owner.address,
      website: owner.website,
      youtube: owner.youtube,
      facebook: owner.facebook,
      instagram: owner.instagram,
      notes: owner.notes,
      created_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  edit_stall(stall: any) {
    const url = this.base_URL + `edit_stall.php`;
    const data = {
      event_id: this.event_id,
      id: stall.id,
      stall_num: stall.stall_num,
      price: stall.price,
      size: stall.size,
      description: stall.description,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  edit_stall_owner(owner: any) {
    const url = this.base_URL + `edit_stall_owner.php`;
    const data = {
      event_id: this.event_id,
      so_id: owner.so_id,
      stall_id: owner.stall_id,
      image_name: owner.image_name,
      owner_name: owner.owner_name,
      owner_number: owner.owner_number,
      email: owner.email,
      company_name: owner.company_name,
      address: owner.address,
      website: owner.website,
      youtube: owner.youtube,
      facebook: owner.facebook,
      instagram: owner.instagram,
      notes: owner.notes,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  get_stall_layout() {
    const url = this.base_URL + `get_stall_layout.php`;
    const data = {
      event_id: this.event_id,
    };
    return this.https.post(url, data);
  }

  edit_stall_layout(layout: any) {
    const url = this.base_URL + `edit_stall_layout.php`;
    const data = {
      event_id: this.event_id,
      layout_image: layout.image_name,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  delete_stall(id: any) {
    const url = this.base_URL + `delete_stall.php`;
    const data = {
      id: id,
    };
    return this.https.post(url, data);
  }

  delete_stall_owner(so_id: any) {
    const url = this.base_URL + `delete_stall_owner.php`;
    const data = {
      so_id: so_id,
    };
    return this.https.post(url, data);
  }

  get_stall_owner(event_id: any) {
    const url = this.base_URL + `get_stall_owner.php`;
    const data = {
      event_id: event_id,
      so_event_id: sessionStorage.getItem("SO_Event_ID"),
    };
    return this.https.post(url, data);
  }

  add_stall_users(user: any) {
    const url = this.base_URL + `add_stall_users.php`;
    const data = {
      so_id: user.so_id,
      name: user.name,
      mobile: user.mobile,
      role: user.role,
      created_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  get_stall_users(so_id: any) {
    const url = this.base_URL + `get_stall_users.php`;
    const data = {
      so_id: so_id,
    };
    return this.https.post(url, data);
  }

  add_admin_users(admin: any) {
    const url = this.base_URL + `add_admin_user.php`;
    const data = {
      event_id: admin.event_id,
      mobile: admin.mobile,
      user_pwd: admin.user_pwd,
      reset_pwd: admin.isResetMode,
      user_name: admin.user_name,
      role: admin.role,
      created_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  add_scanning_point(admin: any) {
    const url = this.base_URL + `add_scanning_point.php`;
    const data = {
      event_id: this.event_id,
      point: admin.point,
      whatsapp_checkin: admin.whatsapp_checkin,
      whatsapp_checkin_msg: admin.whatsapp_checkin_msg,
      whatsapp_checkout: admin.whatsapp_checkout,
      whatsapp_checkout_msg: admin.whatsapp_checkout_msg,
      scan_method: admin.scan_method,
      created_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  edit_scanning_point(admin: any) {
    const url = this.base_URL + `edit_scanning_point.php`;
    const data = {
      event_id: this.event_id,
      point_id: admin.point_id,
      point: admin.point,
      whatsapp_checkin: admin.whatsapp_checkin,
      whatsapp_checkin_msg: admin.whatsapp_checkin_msg,
      whatsapp_checkout: admin.whatsapp_checkout,
      whatsapp_checkout_msg: admin.whatsapp_checkout_msg,
      scan_method: admin.scan_method,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  add_coupon_code(coupon: any) {
    const url = this.base_URL + `add_coupon_code.php`;
    const data = {
      event_id: this.event_id,
      code: coupon.code.replace(/\s+/g, ""),
      amount: coupon.amount,
      coupon_code: coupon.code,
      coupon_type: coupon.coupon_type,
      allowed_count: coupon.allowed_count,
      created_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  edit_coupon_code(coupon: any) {
    const url = this.base_URL + `edit_coupon_code.php`;
    const data = {
      id: coupon.id,
      code: coupon.code.replace(/\s+/g, ""),
      amount: coupon.amount,
      coupon_code: coupon.code,
      coupon_type: coupon.coupon_type,
      allowed_count: coupon.allowed_count,
      total_count: coupon.total_count,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  add_advertise(ad: any) {
    const url = this.base_URL + `add_advertise.php`;
    const data = {
      image_name: ad.image_name,
      link: ad.link,
      created_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  edit_advertise(ad: any) {
    const url = this.base_URL + `edit_advertise.php`;
    const data = {
      ad_id: ad.ad_id,
      image_name: ad.image_name,
      link: ad.link,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  delete_admin_users(id: any) {
    const url = this.base_URL + `delete_admin_user.php`;
    const data = {
      id: id,
    };
    return this.https.post(url, data);
  }

  delete_scanning_point(point_id: any) {
    const url = this.base_URL + `delete_scanning_point.php`;
    const data = {
      point_id: point_id,
    };
    return this.https.post(url, data);
  }

  delete_coupon(id: any) {
    const url = this.base_URL + `delete_coupon_code.php`;
    const data = {
      id: id,
    };
    return this.https.post(url, data);
  }

  add_registration(
    reg: any,
    event_id: any,
    logoPath: any,
    imagePath: any,
    paymentPath: any,
    tic_category: any,
    refercode: any,
    created_by: any,
  ) {
    const url = this.base_URL + `add_registration.php`;
    const data = {
      event_id: event_id,
      image: imagePath,
      id_proof: logoPath,
      payment_ss: paymentPath,
      name: reg.name,
      mobile: reg.mobile,
      email: reg.email,
      city: reg.city,
      state: reg.state,
      address: reg.address,
      date: reg.date,
      allowed_person: reg.allowed_person ? reg.allowed_person : 1,
      whatsapp_status: reg.whatsapp_status,
      tic_category: reg.tic_category,
      field1: reg.field1,
      field2: reg.field2,
      field3: reg.field3,
      field4: reg.field4,
      field5: reg.field5,
      field6: reg.field6,
      field7: reg.field7,
      field8: reg.field8,
      field9: reg.field9,
      field10: reg.field10,
      field11: reg.field11,
      field12: reg.field12,
      field13: reg.field13,
      field14: reg.field14,
      field15: reg.field15,
      field16: reg.field16,
      field17: reg.field17,
      field18: reg.field18,
      field19: reg.field19,
      field20: reg.field20,
      field21: reg.field21,
      field22: reg.field22,
      field23: reg.field23,
      field24: reg.field24,
      field25: reg.field25,
      barcode: reg.barcode,
      refercode: refercode,
      created_by: created_by,
      category_id: reg.category_id,
      ticket_quantity: reg.ticket_quantity,
      is_active: reg.is_active,
    };
    return this.https.post(url, data);
  }

  add_registration_with_regfee(
    reg: any,
    event_id: any,
    logoPath: any,
    imagePath: any,
    paymentPath: any,
    tic_category: any,
    refercode: any,
    created_by: any,
  ) {
    const url = this.base_URL + `add_registration_with_regfee.php`;
    const data = {
      event_id: event_id,
      image: imagePath,
      id_proof: logoPath,
      payment_ss: paymentPath,
      name: reg.name,
      mobile: reg.mobile,
      email: reg.email,
      city: reg.city,
      state: reg.state,
      address: reg.address,
      allowed_person: reg.allowed_person ? reg.allowed_person : 1,
      whatsapp_status: reg.whatsapp_status,
      tic_category: reg.tic_category,
      field1: reg.field1,
      field2: reg.field2,
      field3: reg.field3,
      field4: reg.field4,
      field5: reg.field5,
      field6: reg.field6,
      field7: reg.field7,
      field8: reg.field8,
      field9: reg.field9,
      field10: reg.field10,
      field11: reg.field11,
      field12: reg.field12,
      field13: reg.field13,
      field14: reg.field14,
      field15: reg.field15,
      field16: reg.field16,
      field17: reg.field17,
      field18: reg.field18,
      field19: reg.field19,
      field20: reg.field20,
      field21: reg.field21,
      field22: reg.field22,
      field23: reg.field23,
      field24: reg.field24,
      field25: reg.field25,
      barcode: reg.barcode,
      refercode: refercode,
      created_by: created_by,
      category_id: reg.category_id,
      ticket_quantity: reg.ticket_quantity,
    };
    return this.https.post(url, data);
  }

  createOrder(data: any) {
    const url = this.base_URL + `create_order.php`;
    return this.https.post(url, data);
  }

  payment_response_log(event_id: any, response_data: any) {
    const url = this.base_URL + `payment_response_log.php`;
    const data = {
      event_id: event_id,
      data: response_data,
    };
    return this.https.post(url, data);
  }

  get_payment_details(pid: any, event_id: any) {
    const url =
      this.base_URL +
      `get_payment_details.php?pid=` +
      pid +
      `&event_id=` +
      event_id;
    return this.https.get(url);
  }

  edit_transaction_for_free(transaction: any) {
    const url = this.base_URL + `edit_transaction_for_free_entry.php`;
    const data = {
      event_id: transaction.event_id,
      mem_id: transaction.mem_id,
      amount: transaction.amount,
      status: transaction.status,
      coupon_code: transaction.coupon_code,
      tic_category: transaction.tic_category,
    };
    return this.https.post(url, data);
  }

  getPaymentSetting(event_id: any) {
    const url = this.base_URL + `get_payment_setting.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  editPaymentSetting(setting: any) {
    const url = this.base_URL + `edit_payment_setting.php`;
    const data = {
      event_id: this.event_id,
      name: setting.name,
      razorpay_key: setting.razorpay_key,
      razorpay_secret: setting.razorpay_secret,
      image: setting.image,
      payment_option: setting.payment_option,
      upi_id: setting.upi_id,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  app_editPaymentSetting(setting: any, event_id: any, user_id: any) {
    const url = this.base_URL + `edit_payment_setting.php`;
    const data = {
      event_id: event_id,
      name: setting.name,
      razorpay_key: setting.razorpay_key,
      razorpay_secret: setting.razorpay_secret,
      image: setting.image,
      updated_by: user_id,
    };
    return this.https.post(url, data);
  }

  delete_registration(reg_id: any) {
    const url = this.base_URL + `delete_registration.php`;
    const data = {
      reg_id: reg_id,
    };
    return this.https.post(url, data);
  }

  delete_attendance(id: any, status: any) {
    const url = this.base_URL + `delete_attendance.php`;
    const data = {
      id: id,
      status: status,
      event_id: this.event_id,
    };
    return this.https.post(url, data);
  }

  Generate_Card1(mem_id: any, event_id: any) {
    const url = this.base_URL + `generate_card.php`;

    const data = {
      mem_id: mem_id,
      event_id: event_id,
    };

    return this.https.post(url, data);
  }

  Generate_Card_bulk(event_id: any, create: any) {
    const url = this.base_URL + `generate_card_bulk.php`;

    const data = {
      event_id: event_id,
      create: create
    };

    return this.https.post(url, data);
  }

  checkCard(event_id: any) {
    const url = this.base_URL + `check_card.php`;

    const data = {
      // mem_id: mem_id,
      event_id: event_id
    };

    return this.https.post(url, data);
  }

  get_reg_type(event_id: any) {
    const url = this.base_URL + `get_reg_type.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  get_reg_type_by_id(id: any) {
    const url = this.base_URL + `get_reg_type_by_id.php`;
    const data = {
      id: id,
    };
    return this.https.post(url, data);
  }

  get_reg_fee(mem_id: any, event_id: any) {
    const url = this.base_URL + `get_reg_fee.php`;
    const data = {
      mem_id: mem_id,
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  cash_payment(payment_data: any) {
    const url = this.base_URL + `cash_payment.php`;
    const data = {
      mem_id: payment_data.mem_id,
      event_id: payment_data.event_id,
      amount: payment_data.amount,
      order_id: payment_data.order_id,
      status: payment_data.status,
      method: payment_data.method,
      name: payment_data.name,
      mobile: payment_data.mobile,
      created_at: payment_data.created_at,
    };
    return this.https.post(url, data);
  }

  get_all_admin_users() {
    const url = this.base_URL + `get_all_admin_users.php`;

    return this.https.get(url);
  }

  get_unsend() {
    const url = this.base_URL + `get_unsend.php`;
    const data = {
      event_id: this.event_id,
    };
    return this.https.post(url, data);
  }

  get_all() {
    const url = this.base_URL + `get_all.php`;
    const data = {
      event_id: this.event_id,
    };
    return this.https.post(url, data);
  }

  download_pass(pass: any, path: any) {
    const url = `https://api.vthinksolution.com/scanmezip`;
    const data = {
      pass: pass,
      path: path,
    };
    return this.https.post(url, data);
  }

  delete_zip(zipPath: string) {
    return this.https.post(this.base_URL + `delete_zip.php`, {
      zip_path: zipPath,
    });
  }

  Send_Whatsapp(whatsapp: any, event_id: any, message: any) {
    const url = this.base_URL + `send_bluewaba1.php`;

    const data = {
      mem_id: whatsapp.mem_id,
      event_id: event_id,
      msg: message,

      email: whatsapp.email,
      name: whatsapp.name,
      mobile: whatsapp.mobile,
      city: whatsapp.city,
      state: whatsapp.state,
      address: whatsapp.address,
      date: whatsapp.date,
      allowed_person: whatsapp.allowed_person ? whatsapp.allowed_person : 1,
      whatsapp_status: whatsapp.whatsapp_status,
      tic_category: whatsapp.tic_category,
      field1: whatsapp.field1,
      field2: whatsapp.field2,
      field3: whatsapp.field3,
      field4: whatsapp.field4,
      field5: whatsapp.field5,
      field6: whatsapp.field6,
      field7: whatsapp.field7,
      field8: whatsapp.field8,
      field9: whatsapp.field9,
      field10: whatsapp.field10,
      field11: whatsapp.field11,
      field12: whatsapp.field12,
      field13: whatsapp.field13,
      field14: whatsapp.field14,
      field15: whatsapp.field15,
      field16: whatsapp.field16,
      field17: whatsapp.field17,
      field18: whatsapp.field18,
      field19: whatsapp.field19,
      field20: whatsapp.field20,
      field21: whatsapp.field21,
      field22: whatsapp.field22,
      field23: whatsapp.field23,
      field24: whatsapp.field24,
      field25: whatsapp.field25,
    };
    return this.https.post(url, data);
  }

  ImportMember(csvfile: any) {
    const url = this.base_URL + `import_registration.php`;
    const data = {
      event_id: this.event_id,
      csvfile: csvfile,
      created_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  uploadcsvmat(imagefileURL: File) {
    const url = this.base_URL + `uploadcsv.php`;
    const formData = new FormData();
    formData.append("csv_file", imagefileURL);

    return this.https.post(url, formData);
  }

  export(export_data: any) {
    const url = this.base_URL + `export.php`;
    const data = {
      event_id: this.event_id,
      type: export_data.type,
      dummy: export_data.dummy,
      point: export_data.point,
      date: export_data.date,
      reg_date: export_data.reg_date,
      tic_category: export_data.category,
      category_id: export_data.category_id,
    };
    return this.https.post(url, data, { responseType: "text" });
  }

  export_stall_scan(so_id: any) {
    const url = this.base_URL + `export_stall_scan.php`;
    const data = {
      so_id: so_id,
    };
    return this.https.post(url, data, { responseType: "text" });
  }

  get_card(event_id: any) {
    const url = this.base_URL + `get_icard.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  edit_icard(card: any) {
    const url = this.base_URL + `edit_icard.php`;
    const data = {
      event_id: card.event_id,
      category_id: card.category_id,
      design_name: card.design_name,
      type: card.type,
      image1: card.image1,
      image2: card.image2,
      image3: card.image3,
      scan_type: card.scan_type,
      content: card.content,
      show_qr: card.show_qr,
      show_id: card.show_id,
      width: card.width,
      height: card.height,
      qr_width: card.qr_width,
      qr_height: card.qr_height,
      x_axis: card.x_axis,
      y_axis: card.y_axis,
      pdf_bg: card.pdf_bg,
      layout: card.layout,
      color: card.color,
      font_size: card.font_size,
      company_ad: card.company_ad,
      company_ad_text: card.company_ad_text,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  app_edit_icard(card: any, user_id: any) {
    const url = this.base_URL + `edit_icard.php`;
    const data = {
      event_id: card.event_id,
      design_name: card.design_name,
      type: card.type,
      image1: card.image1,
      image2: card.image2,
      image3: card.image3,
      scan_type: card.scan_type,
      content: card.content,
      width: card.width,
      height: card.height,
      qr_width: card.qr_width,
      qr_height: card.qr_height,
      x_axis: card.x_axis,
      y_axis: card.y_axis,
      pdf_bg: card.pdf_bg,
      layout: card.layout,
      color: card.color,
      font_size: card.font_size,
      company_ad: card.company_ad,
      company_ad_text: card.company_ad_text,
      updated_by: user_id,
    };
    return this.https.post(url, data);
  }

  getGallery(event_id: any) {
    const url = this.base_URL + `get_gallery.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  getGalleryById(gallery_id: any, event_id: any) {
    const url = this.base_URL + `get_gallery_by_id.php`;
    const data = {
      gallery_id: gallery_id,
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  addGallery(addimgdata: any) {
    const url = this.base_URL + `add_gallery.php`;
    const data = {
      event_id: this.event_id,
      title: addimgdata.title,
      description: addimgdata.description,
      image_name: addimgdata.image_name,
      created_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  editGallery(editimg: any) {
    const url = this.base_URL + `edit_gallery.php`;
    const data = {
      event_id: editimg.event_id,
      title: editimg.title,
      description: editimg.description,
      gallery_id: editimg.gallery_id,
      thumb_id: editimg.thumb_id,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  deleteGallery(gallery_id: any) {
    const url = this.base_URL + `delete_gallery.php`;
    const data = {
      gallery_id: gallery_id,
      event_id: this.event_id,
    };
    return this.https.post(url, data);
  }

  getimagebyid(gallery_id: any, event_id: any) {
    const url = this.base_URL + `get_image_by_id.php`;
    const data = {
      gallery_id: gallery_id,
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  Addimage(addimagegallery: any) {
    const url = this.base_URL + `add_image.php`;
    const data = {
      gallery_id: addimagegallery.gallery_id,
      event_id: addimagegallery.event_id,
      image_name: addimagegallery.image_name,
    };
    return this.https.post(url, data);
  }

  Deleteimage(event_id: any, img_id: any) {
    const url = this.base_URL + `delete_image.php`;
    const data = {
      event_id: event_id,
      img_id: img_id,
    };
    return this.https.post(url, data);
  }

  dashboard_count(role: any) {
    const url = this.base_URL + `dashboard_count.php`;
    const data = {
      event_id: this.event_id,
      role: role,
      user_id: this.updated_by,
    };
    return this.https.post(url, data);
  }

  // ==================== ANALYTICS METHODS ====================

  getAnalyticsData(role: any) {
    // Reuses enhanced dashboard_count.php which now includes all analytics
    return this.dashboard_count(role);
  }

  getRevenueTrendData(event_id: any) {
    const url = this.base_URL + `get_transactions.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  checkWhatsappStatus(wamid: any, reg_id: any) {
    const url = this.base_URL + `check_wamid_status.php`;
    const data = {
      wamid: wamid,
      reg_id: reg_id,
      event_id: this.event_id
    };
    return this.https.post(url, data);
  }


  getRegistrationData(event_id: any, reg_date: any, category_id: any) {
    const url = this.base_URL + `get_registrations.php`;
    const data = {
      event_id: event_id,
      reg_date: reg_date,
      category_id: category_id,

    };
    return this.https.post(url, data);
  }

  getCheckinsData(event_id: any, reg_date: any, category_id: any) {
    const url = this.base_URL + `get_checkins.php`;
    const data = {
      event_id: event_id,
      reg_date: reg_date,
      category_id: category_id,

    };
    return this.https.post(url, data);
  }

  getCheckpointAnalytics(event_id: any) {
    const url = this.base_URL + `get_scanning_point.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  active_event(event_id: any, is_active: any) {
    const url = this.base_URL + `active_event.php`;
    const data = {
      event_id: event_id,
      is_active: is_active,
    };
    return this.https.post(url, data);
  }
  active_ad(ad_id: any, is_active: any) {
    const url = this.base_URL + `active_advertise.php`;
    const data = {
      ad_id: ad_id,
      is_active: is_active,
    };
    return this.https.post(url, data);
  }

  active_admin(id: any, is_active: any) {
    const url = this.base_URL + `active_admin.php`;
    const data = {
      id: id,
      is_active: is_active,
    };
    return this.https.post(url, data);
  }

  active_ticket_cat(category_id: any, is_active: any) {
    const url = this.base_URL + `active_ticket_cat.php`;
    const data = {
      category_id: category_id,
      is_active: is_active,
    };
    return this.https.post(url, data);
  }

  docheckinout(data: any) {
    const url = this.base_URL + `attendance.php`;
    const updatedData = { ...data, created_by: this.updated_by };
    return this.https.post(url, updatedData);
  }

  send_push(MessageData: any) {
    const url = this.base_URL + `send_push.php`;
    const data = {
      title: MessageData.title,
      msg: MessageData.msg,
      event_id: MessageData.event_id,
    };
    return this.https.post(url, data);
  }

  get_ticket_master() {
    const url = this.base_URL + `get_ticket_master.php`;
    const data = {
      event_id: this.event_id,
    };
    return this.https.post(url, data);
  }

  get_ticket_by_id(id: any) {
    const url = this.base_URL + `get_ticket_by_id.php`;
    const data = {
      id: id,
    };
    return this.https.post(url, data);
  }

  edit_ticket(ticket: any) {
    const url = this.base_URL + `edit_ticket.php`;
    const data = {
      id: ticket.id,
      row: ticket.row,
      seat_no: ticket.seat_no,
      updated_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  get_ticket_category(event_id: any) {
    const url = this.base_URL + `get_ticket_category.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  get_all_ticket_category(event_id: any) {
    const url = this.base_URL + `get_all_ticket_category.php`;
    const data = {
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  add_ticket_category(ticket: any) {
    const url = this.base_URL + `add_ticket_category.php`;
    const data = {
      event_id: ticket.event_id,
      user_id: ticket.user_id,
      auto_assign: ticket.auto_assign,
      category: ticket.category,
      color: ticket.color,
      total_category_tickets: ticket.total_category_tickets,
      max_allowed: ticket.max_allowed,
      ticket_array: ticket.ticket_array,
      ticket_amount: ticket.ticket_amount,
      convenience_type: ticket.convenience_type,
      convenience_fee: ticket.convenience_fee,
      total_convenience_fee: ticket.total_convenience_fee,
      cgst_per: ticket.cgst_per,
      sgst_per: ticket.sgst_per,
      igst_per: ticket.igst_per,
      cgst_amt: ticket.cgst_amt,
      sgst_amt: ticket.sgst_amt,
      igst_amt: ticket.igst_amt,
      other_charges: ticket.other_charges,
      total_charges: ticket.total_charges,
      total_amount: ticket.total_amount,
      created_by: this.updated_by,
    };
    return this.https.post(url, data);
  }

  app_add_ticket_category(ticket: any) {
    const url = this.base_URL + `add_ticket_category.php`;
    const data = {
      event_id: ticket.event_id,
      auto_assign: ticket.auto_assign,
      category: ticket.category,
      color: ticket.color,
      total_category_tickets: ticket.total_category_tickets,
      max_allowed: ticket.max_allowed,
      ticket_array: ticket.ticket_array,
      ticket_amount: ticket.ticket_amount,
      convenience_type: ticket.convenience_type,
      convenience_fee: ticket.convenience_fee,
      total_convenience_fee: ticket.total_convenience_fee,
      cgst_per: ticket.cgst_per,
      sgst_per: ticket.sgst_per,
      igst_per: ticket.igst_per,
      cgst_amt: ticket.cgst_amt,
      sgst_amt: ticket.sgst_amt,
      igst_amt: ticket.igst_amt,
      other_charges: ticket.other_charges,
      total_charges: ticket.total_charges,
      total_amount: ticket.total_amount,
      created_by: ticket.user_id,
    };
    return this.https.post(url, data);
  }

  get_ticket_category_by_id(category_id: any) {
    const url = this.base_URL + `get_ticket_category_by_id.php`;
    const data = {
      category_id: category_id,
    };
    return this.https.post(url, data);
  }

  get_ticket_category_by_category(category: any, event_id: any) {
    const url = this.base_URL + `get_ticket_category_by_category.php`;
    const data = {
      category: category[0].category,
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  getTicketPricing(category: any, event_id: any) {
    const url = this.base_URL + `get_ticket_category_by_category.php`;
    const data = {
      category: category,
      event_id: event_id,
    };
    return this.https.post(url, data);
  }

  edit_ticket_category(ticket: any) {
    const url = this.base_URL + `edit_ticket_category.php`;

    const data = {
      category_id: ticket.category_id,
      event_id: ticket.event_id,
      category: ticket.category,
      color: ticket.color,
      total_category_tickets: ticket.total_category_tickets,
      max_allowed: ticket.max_allowed,
      auto_assign: ticket.auto_assign,

      ticket_amount: ticket.ticket_amount,
      convenience_type: ticket.convenience_type,
      convenience_fee: ticket.convenience_fee,
      total_convenience_fee: ticket.total_convenience_fee,

      cgst_per: ticket.cgst_per,
      sgst_per: ticket.sgst_per,
      igst_per: ticket.igst_per,

      cgst_amt: ticket.cgst_amt,
      sgst_amt: ticket.sgst_amt,
      igst_amt: ticket.igst_amt,

      other_charges: ticket.other_charges,
      total_charges: ticket.total_charges,
      total_amount: ticket.total_amount,

      updated_by: ticket.updated_by,
    };

    return this.https.post(url, data);
  }

  delete_ticket_category(category_id: any) {
    const url = this.base_URL + `delete_ticket_category.php`;
    const data = {
      category_id: category_id,
    };
    return this.https.post(url, data);
  }

  get_unassigned_tickets(mem_id: any, event_id: any) {
    const url = this.base_URL + `get_unassigned_tickets.php`;
    var data = {
      mem_id: mem_id,
      event_id: event_id,
      // 'pagesize': pagesize,
    };
    return this.https.post(url, data);
  }

  assign_ticket(data: any) {
    const url = this.base_URL + `assign_ticket.php`;
    return this.https.post(url, data);
  }

  getProductsForStall(so_id: number) {
    const url = this.base_URL + `get_products.php`;
    const data = {
      so_id: so_id,
    };
    return this.https.post(url, data);
  }

  add_so_events(data: any) {
    const url = this.base_URL + `add_so_events.php`;
    return this.https.post(url, data);
  }

  getSoEventDetail(so_event_id: any) {
    const url = this.base_URL + "get_so_event_by_id.php";
    return this.https.post(url, { so_event_id: so_event_id });
  }

  editSoEventDetail(DetailData: any) {
    const url = this.base_URL + "edit_so_event.php";
    const data = {
      so_event_id: DetailData.so_event_id,
      event_name: DetailData.event_name,
      event_address: DetailData.event_address,
      from_date: DetailData.from_date,
      to_date: DetailData.to_date,
    };
    return this.https.post(url, data);
  }

  approve_registration(reg_id: any, is_approved: any) {
    const url = this.base_URL + "approve_registration.php";
    const data = {
      reg_id: reg_id,
      is_approved: is_approved,
    };
    return this.https.post(url, data);
  }

  /**
   * Get report count data for all report types
   * Payload: event_id, point, date, reg_date, category_id, tic_category
   */
  getReportCount(payload: any) {
    const url = this.base_URL + `get_report_count.php`;
    const data = {
      event_id: payload.event_id,
      point: payload.point || '',
      date: payload.date || '',
      reg_date: payload.reg_date || '',
      category_id: payload.category_id || '',
      tic_category: payload.tic_category || ''
    };
    return this.https.post(url, data);
  }

  /**
   * Get check-in data
   * Payload: event_id, point, date, tic_category
   */
  getCheckins(payload: any) {
    const url = this.base_URL + `get_checkins.php`;
    const data = {
      event_id: payload.event_id,
      point: payload.point || '',
      date: payload.date || '',
      end_date: payload.end_date || '',
      tic_category: payload.tic_category || ''
    };
    return this.https.post(url, data);
  }

  /**
   * Get check-out data
   * Payload: event_id, point, date, tic_category
   */
  getCheckouts(payload: any) {
    const url = this.base_URL + `get_checkouts.php`;
    const data = {
      event_id: payload.event_id,
      point: payload.point || '',
      date: payload.date || '',
      end_date: payload.end_date || '',
      tic_category: payload.tic_category || ''
    };
    return this.https.post(url, data);
  }

  /**
   * Get not visited registrations
   * Payload: event_id, reg_date, category_id
   */
  getNotVisited(payload: any) {
    const url = this.base_URL + `get_notvisited.php`;
    const data = {
      event_id: payload.event_id,
      reg_date: payload.reg_date || '',
      category_id: payload.category_id || ''
    };
    return this.https.post(url, data);
  }

  getRedeemRequests(so_id: any) {
    const url = this.base_URL + `get_redeem_requests.php`;
    const data = {
      so_id: so_id,
    };
    return this.https.post(url, data);
  }

  approveRedeemRequest(ledger_id: any, action: any) {
    console.log(action);
    const url = this.base_URL + `approve_redeem_request.php`;
    const data = {
      ledger_id: ledger_id,
      action: action,
    };
    return this.https.post(url, data);
  }

  uploadBlogImage(image: any, folder: any, fileName: any) {
    const url = this.base_URL + `uploadblogimage.php`;

    const data = {
      image: image,
      folder: folder,
      file_name: fileName
    };
    return this.https.post(url, data);
  }

  getBlog() {
    const url = this.base_URL + `get_blog.php`;
    return this.https.get(url);
  }

  deleteBlog(blog_id: any) {
    const url = this.base_URL + `delete_blog.php`;
    const data = {
      blog_id: blog_id,
    };
    return this.https.post(url, data, { withCredentials: true });
  }

  createBlog(payload: any) {
    return this.https.post(
      `${this.base_URL}add_blog.php`,
      payload,
      { withCredentials: true }
    );
  }

  updateBlog(blogId: string, payload: any) {
    // Ensure blog_id is included in the JSON payload
    const body = { ...payload, blog_id: blogId };

    return this.https.post(
      `${this.base_URL}edit_blog.php`,
      body,
      { withCredentials: true }
    );
  }

}
